import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcNotification(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.75 3.75a1.25 1.25 0 1 1 2.5 0v.87A6.5 6.5 0 0 1 18.5 11v6.5h1.25a.75.75 0 0 1 0 1.5H4.25a.75.75 0 0 1 0-1.5H5.5V11a6.5 6.5 0 0 1 5.25-6.38zM7 17.5h10V11a5 5 0 0 0-10 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.75 20a1.75 1.75 0 1 1-3.5 0z"
  }));
}
var IcNotification = createNolIcon(/*#__PURE__*/forwardRef(SvgIcNotification));

export { IcNotification as I };
